import bem from 'utils/bem';

export const basePlayerBlock = bem('clip-select-player');
export const containerBlock = bem('clip-select-video-player-container');
